import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { LDFlagsService } from '@dg/shared-services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-add-experience-menu',
  templateUrl: './add-experience-menu.component.html',
  styleUrls: ['./add-experience-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddExperienceMenuComponent {
  @Output() public addExperience = new EventEmitter<string>();

  public i18n = this.translateService.instant([
    'Core_Add',
    'Core_JobRoleLiteral',
    'Opportunities_TypeProject',
    'Opportunities_TypeMentorship',
    'Opportunities_TypeMenteeship',
    'Opportunities_TypeShadowing',
    'Opportunities_TypeStretchAssignment',
    'Opportunities_TypeOther',
    'Core_AddExperience',
  ]);

  public isAddExperiencePopoverOpen = false;
  public experienceTypes = [
    {
      id: 'JobRole',
      inputSubType: this.i18n.Core_JobRoleLiteral,
    },
    {
      id: 'Project',
      inputSubType: this.i18n.Opportunities_TypeProject,
    },
    {
      id: 'Mentorship',
      inputSubType: this.i18n.Opportunities_TypeMentorship,
    },
    {
      id: 'Menteeship',
      inputSubType: this.i18n.Opportunities_TypeMenteeship,
    },
    {
      id: 'Shadowing',
      inputSubType: this.i18n.Opportunities_TypeShadowing,
    },
    {
      id: 'StretchAssignment',
      inputSubType: this.i18n.Opportunities_TypeStretchAssignment,
    },
    {
      id: 'Other',
      inputSubType: this.i18n.Opportunities_TypeOther,
    },
  ];

  constructor(
    private translateService: TranslateService,
    private ldFlagsService: LDFlagsService
  ) {}

  public get showExperienceTypes() {
    return this.ldFlagsService.showExperienceTypes;
  }

  public addExperiencePopoverToggled(popoverState: boolean): void {
    this.isAddExperiencePopoverOpen = popoverState;
  }

  public onAddExperience(id: string) {
    this.addExperience.emit(id);
  }
}
